const colorPalette = [
  '#FF8A65',
  '#FFD54F',
  '#FFEE58',
  '#DCE775',
  '#DCE775',
  '#AED581',
  '#81C784',
  '#4DD0E1',
  '#64B5F6',
  '#7986CB',
  '#9575CD',
  '#F06292',
];

export const formatTreatmentAndTrialGroups = (allGroups, groupsInTreatment) => {
  const { groupLabels, groupDescriptions, groupColors } = allGroups.reduce(
    (acc, curr) => {
      if (!groupsInTreatment.includes(curr.label) || acc.groupLabels.includes(curr.label)) {
        return acc;
      }

      acc.groupLabels.push(curr.label);
      acc.groupDescriptions[curr.label] = curr.description;
      if (acc.currentColorIndex > colorPalette.length - 1) {
        acc.currentColorIndex = 0;
      }
      acc.groupColors[curr.label] = colorPalette[acc.currentColorIndex];
      acc.currentColorIndex += 1;

      return acc;
    },
    {
      groupLabels: [],
      groupDescriptions: {},
      groupColors: {
        fallback: colorPalette[0]
      },
      currentColorIndex: 0
    }
  );

  return {
    groupLabels,
    groupDescriptions,
    groupColors
  };
};
